import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from './login.js'
import Public from './public.js'
import Site from './site.js'
import Institution from './institution/index.js'
import Store from '@/store/index.js'
import Apply from './apply/index.js'
import Ai from './apply/ai.js'

Vue.use(VueRouter)

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push

// 修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  ...Public,
  ...Login,
  ...Site,
  ...Apply,
  ...Institution,
  ...Ai
]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

// 路由前置守卫
router.beforeEach((to, from, next) => {
  const accessToken = Vue.prototype.getToken()
  const userInfo = JSON.parse(localStorage.getItem('USER_INFO'))

  // 记录切换前的 labelType
  const previousLabelType = Store.state.labelType
  let newLabelType = null

  if (to.meta.auth && !accessToken) { // 未登录，但是跳转需要登录的页面
    newLabelType = -1
    Store.dispatch('updateLabelType', newLabelType)
    next({
      path: '/admin/login'
    })
  } else if (!to.meta.auth && accessToken && userInfo) { // 登录了，但是跳转不需要登录的页面
    newLabelType = userInfo.staff_type
    Store.dispatch('updateLabelType', newLabelType)
    next({
      path: userInfo.toRoute
    })
  } else { // 正常跳转
    newLabelType = to.meta.headType
    Store.dispatch('updateLabelType', newLabelType)
    next()
  }

  // 当从应用路由（0）切换到站点路由（1）或机构路由（2）时，只清空内存中的置顶插件，不清空 localStorage
  if (previousLabelType === 0 && (newLabelType === 1 || newLabelType === 2)) {
    Store.dispatch('clearTopPlugin', { clearLocalStorage: false })
  }

  // 从浏览器恢复登录状态
  if (accessToken && userInfo && Store.state.userInfo.toRoute == null) {
    // 不清空置顶插件，因为不同账号的 localStorage key 不同（包含 userId），不会互相影响
    // 每个账号的置顶插件会永久保存在 localStorage 中，直到用户手动清除或浏览器清除
    Store.dispatch('updateUserInfo', userInfo)
  }

  // 从浏览器恢复应用信息
  const applyInfo = localStorage.getItem('APPLY_INFO')
  if (applyInfo) {
    const parsedApplyInfo = JSON.parse(applyInfo)
    const previousApplyId = Store.state.applyInfo.apply_id
    // 如果应用ID发生变化，只清空内存中的置顶插件，不清空 localStorage（因为 localStorage 是按应用ID隔离的）
    if (previousApplyId && previousApplyId !== parsedApplyInfo.apply_id) {
      Store.dispatch('clearTopPlugin', { clearLocalStorage: false })
    }
    // updateApplyInfo 中会自动恢复置顶插件，但需要检查当前路由类型
    Store.dispatch('updateApplyInfo', {
      applyInfo: parsedApplyInfo
    })
    // 只有在应用路由（labelType === 0）时才恢复置顶插件
    // 如果直接访问站点后台（labelType === 1），不应该恢复置顶插件
    if (newLabelType === 0 && accessToken && userInfo) {
      // 确保用户信息已更新
      if (!Store.state.userInfo.toRoute && userInfo) {
        Store.dispatch('updateUserInfo', userInfo)
      }
      // 延迟恢复，确保应用信息已更新
      setTimeout(() => {
        Store.dispatch('restoreTopPlugin')
      }, 100)
    } else if (newLabelType === 1 || newLabelType === 2) {
      // 如果是站点路由或机构路由，清空内存中的置顶插件，但不清空 localStorage
      Store.dispatch('clearTopPlugin', { clearLocalStorage: false })
    }
  } else {
    // 如果没有应用信息，但之前有应用信息，说明退出了应用
    // 只清空内存中的置顶插件，不清空 localStorage（因为可能是返回系统，下次还会进入）
    if (Store.state.applyInfo.apply_id) {
      Store.dispatch('clearTopPlugin', { clearLocalStorage: false })
    }
  }

  // 从浏览器恢复企业信息
  const insInfo = localStorage.getItem('INS_INFO')
  if (insInfo) {
    Store.dispatch('setInsInfo', {
      ...JSON.parse(insInfo)
    })
  }

  // 只在企业路由时恢复和保留企业相关的状态
  // 切换到非企业路由时，清除这些状态（避免状态混乱）
  if (newLabelType === 2) {
    // 如果访问的是场景路由，优先从URL中提取sceneId并保存（URL更准确）
    if (to.path.startsWith('/admin/institution/scene/')) {
      const sceneIdMatch = to.path.match(/\/admin\/institution\/scene\/(\d+)/)
      if (sceneIdMatch && sceneIdMatch[1]) {
        const sceneId = parseInt(sceneIdMatch[1])
        Store.dispatch('setSelectedSceneId', sceneId)
      }
    } else {
      // 非场景路由：从localStorage恢复选中场景ID（转换为数字，确保类型一致）
      const selectedSceneId = localStorage.getItem('SELECTED_SCENE_ID')
      if (selectedSceneId) {
        Store.dispatch('setSelectedSceneId', parseInt(selectedSceneId))
      }
    }
  } else if (previousLabelType === 2 && newLabelType !== 2) {
    // 从企业路由切换到非企业路由：清除企业相关状态
    Store.dispatch('setSelectedSceneId', null)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js